import { ca } from '@cian/analytics';

export function trackClickPromoListLink() {
  ca('eventSite', {
    name: 'oldevent',
    action: 'Click',
    category: 'Promo',
    label: 'to_promo',
  });
}
